<template>
  <AConfigProvider :locale="props.locale">
    <template #renderEmpty v-if="isHaveRenderEmptySlot">
      <slot name="renderEmpty" />
    </template>

    <slot />
  </AConfigProvider>
</template>

<script setup lang="ts">
import {computed, useSlots} from 'vue';
import {ConfigProvider as AConfigProvider} from 'ant-design-vue';
import type {Locale} from 'ant-design-vue/es/locale-provider';

interface IProps {
  locale?: Locale;
}

const slots = useSlots();
const props = defineProps<IProps>();

const isHaveRenderEmptySlot = computed(() => slots.renderEmpty != null);
</script>

<style lang="scss" />
